import { render } from "./CategoryBlock.vue?vue&type=template&id=a3e7b6f4"
import script from "./CategoryBlock.vue?vue&type=script&lang=js"
export * from "./CategoryBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__